import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SharedService } from '../../../../services/shared.service';
import { CommonService } from '../../../services/common.service';
import { userApi } from '../../../model/constants/endpoints';
import { PanelGuId } from '../../../model/constants/AppConstants';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent implements OnInit, AfterViewInit {

  forgotPasswordForm: FormGroup;
  showMessageBox: any = '';
  isShowLoader: boolean = false;
  constructor(
    public sharedService: SharedService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.handleForgotForm()
  }
  ngAfterViewInit(): void {
  }

  handleForgotForm() {
    const emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    this.forgotPasswordForm = this.commonService.fb.group({
      email: new FormControl('', [Validators.required, Validators.email, Validators.pattern(emailPattern)])
    })
  }

  onSubmitForgotForm() {
    if (this.forgotPasswordForm.invalid) {
      this.forgotPasswordForm.markAllAsTouched();
      this.commonService.translate.get('validEmailMessage').subscribe((res: string) => {
        this.commonService.userService.showError(res)
      });
      return;
    }
   this.isShowLoader = true;
    this.commonService.spinner.show()
    const body = {
      email: this.forgotPasswordForm.value.email,
    }
    this.commonService.httpApiService.post(userApi.forgotPassword, body).then((res: any) => {
      this.commonService.translate.get('reset_Passwrod_message').subscribe((res: string) => {
        this.showMessageBox = res;
      });
      this.commonService.spinner.hide();
      setTimeout(() => {
        this.commonService.dialog.closeAll()
      }, 5000);
      this.isShowLoader = false;
    }).catch((error) => {
      this.isShowLoader = false;
      this.commonService.spinner.hide();
      this.commonService.translate.get('noUserFound').subscribe((res: string) => {
        this.showMessageBox = res;
      });
       setTimeout(() => {
         this.commonService.dialog.closeAll()
      }, 5000);
    })
    this.forgotPasswordForm.reset()
  }

  closeDialog() {
    this.commonService.dialog.closeAll()
  }

}
